module.exports = __webpack_public_path__ + "static/img/wx.e833f1f.png";


//////////////////
// WEBPACK FOOTER
// ./static/home/wx.png
// module id = pDv+
// module chunks = 1